import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { useModal } from '@/components/modal/useModal';
import { FC } from 'react';
import { CreateFromBundlesModal } from './CreateFromBundlesModal';

const CreateFromBundlesButton: FC = () => {
  const modalProps = useModal();

  return (
    <>
      <CreateFromBundlesModal {...modalProps} />
      <Button
        variant={ButtonVariant.Secondary}
        onClick={() => {
          modalProps.open();
        }}
      >
        Create from Bundles
      </Button>
    </>
  );
};

export default CreateFromBundlesButton;
